import { reportClientError } from './reportClientError';

let installed = false;

/**
 * Catches what the React boundary cannot: throws from event handlers, timers,
 * async work, and rejected promises nobody awaited.
 */
export const installGlobalErrorHandlers = (): void => {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event: ErrorEvent) => {
    // Failed <img>/<script> loads surface here too, with no error object.
    if (!event.error && !event.message) return;
    reportClientError('window', event.error ?? event.message);
  });

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    reportClientError('unhandledrejection', event.reason);
  });
};

export const resetGlobalErrorHandlersForTests = (): void => {
  installed = false;
};
